import { useAsertoApiWithAuth0Token, v1Api } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useAccountClient() {
  const { tenantServiceUrl } = useConfig()
  return useAsertoApiWithAuth0Token(v1Api(tenantServiceUrl))
}
